import React from "react";
import { StyledBubbleItem } from "./style";

type UserBubbleProps = {
  content: string;
};

const UserBubble = ({ content }: UserBubbleProps) => {
  return (
    <StyledBubbleItem className="user-bubble">
      <div
        className="user-bubble-content"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </StyledBubbleItem>
  );
};

export default UserBubble;
